import { render } from "./IndexThumbNail.vue?vue&type=template&id=23779b35&scoped=true"
import script from "./IndexThumbNail.vue?vue&type=script&lang=js"
export * from "./IndexThumbNail.vue?vue&type=script&lang=js"

import "./IndexThumbNail.vue?vue&type=style&index=0&id=23779b35&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23779b35"]])

export default __exports__